// components.
import { TrackerEmpty } from './components/TrackerEmpty';
import { handleStatusStep } from './components/tracker.utils';
import { CircleTracker } from './components/TrackerItems/CircleTracker';
import { InfoTracker } from './components/TrackerItems/InfoTracker';
import { LineTracker } from './components/TrackerItems/LineTracker';

// domains.
import { useOrchestratorSteps } from '@domains/orchestrator-pricing-committee/hooks/useOrchestratorSteps';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';
import {
  getSelectedStep,
  setSelectedStep,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';

interface WorkflowStep {
  name: string;
  status: string;
  start_at?: string;
  end_at?: string;
}

export const OrchestratorTrackerLine = () => {
  const dispatch = useDispatch();
  const selectedStep = useSelector(getSelectedStep);

  const { steps } = useOrchestratorSteps();
  const { currentOrchestrator } = useCurrentOrchestrator();
  const { data } = currentOrchestrator;

  if (!data?.workflow_steps) {
    return <TrackerEmpty />;
  }

  const { workflow_steps } = data;

  const stepMap = new Map<string, WorkflowStep>();
  workflow_steps.forEach(ws => stepMap.set(ws.name, ws));

  return (
    <div className="py-3">
      <div className="d-flex flex-column position-relative pt-1">
        {steps.map((stepName, index) => {
          const stepData = stepMap.get(stepName);

          const { status, dateStr } = handleStatusStep({
            status: stepData?.status,
            startAt: stepData?.start_at,
            endAt: stepData?.end_at,
          });

          const isCompleted = status === 'COMPLETED';
          const isInProgress = status === 'IN_PROGRESS';
          const isRejected = status === 'REJECTED';

          const colorIfInProgress = isInProgress && 'orange';
          const colorIfIsCompleted = isCompleted && 'purple';
          const colorIfRejected = isRejected && 'red';
          const colorStatus =
            colorIfInProgress ||
            colorIfIsCompleted ||
            colorIfRejected ||
            '#ccc';

          const stepContent = (
            <div
              className="d-flex align-items-start"
              data-testid={`step-${index}`}
              onClick={() => dispatch(setSelectedStep(stepName))}
              style={{ cursor: 'pointer' }}
              aria-hidden="true"
            >
              <CircleTracker colorStatus={colorStatus} />
              <InfoTracker
                stepName={stepName}
                date={dateStr}
                isCompleted={isCompleted}
                isInProgress={isInProgress}
                isRejected={isRejected}
                colorStatus={colorStatus}
                stepData={stepData}
              />
            </div>
          );

          const isSelected = selectedStep === stepName;

          return (
            <div key={stepName} className="mb-4">
              {isSelected ? (
                <Card data-testid={`card-step-${index}`} className="mb-4">
                  <Card.Body className="p-2">{stepContent}</Card.Body>
                </Card>
              ) : (
                stepContent
              )}
              <LineTracker
                colorStatus={colorStatus}
                position={index}
                steps={steps}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
